// extracted by mini-css-extract-plugin
module.exports = {"container":"form_container__3tU_K","filesColumn":"form_filesColumn__1zW9n","files":"form_files__2wYJL","suggestColumn":"form_suggestColumn__3YT_r","footer":"form_footer__3_2Ir"};